import React from 'react';

import PropTypes from 'prop-types';

const WorkspaceDetails = ({ name, phone }) => (
  <div className="grid flex-1 text-sm leading-tight">
    <span className="truncate font-medium text-foreground">{name}</span>
    <span className="truncate text-xs text-foreground">{phone}</span>
  </div>
);

WorkspaceDetails.propTypes = {
  name: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
};

export default WorkspaceDetails;
